import Handler from '@/core/domain/usecase/handler';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import { Ruler } from '../../domain/model/ruler';

export interface ChangeRulerRepository {
  (id: number, data: object): Promise<Ruler>
}

const changeRulerRepository = (axios: AxiosInstance): ChangeRulerRepository => async (id: number, data: object) => {
  try {
    const response: AxiosResponse = await axios.put(`/ruler/${id}`,
      data
    )
    return response.data
  } catch (err: any | AxiosError) {
    if (err.isAxiosError) {
      throw new Handler().trataErro(err)
    } else {
      throw err
    }
  }
}

export default changeRulerRepository

